import React, { PureComponent } from "react";
import { Input, Select, Table, Checkbox, Button, Upload, Message } from "element-react";
import upload from 'images/preferential/upload.png';
import download from 'images/preferential/download.png';
import { getToken, getCurrentUser } from 'utils/storage';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import { removeAll } from 'utils/storage';
import "./applicationProcess.css";

const city = [
  { value: "三亚市", label: "三亚市" },
  { value: "桂林市", label: "桂林市" },
  { value: "百色市", label: "百色市" }
];

const area = [
  { value: "海棠区", label: "海棠区" },
  { value: "桂林市", label: "桂林市" },
  { value: "百色市", label: "百色市" }
];

const areaSmall = [
  { value: "海棠区办事处", label: "海棠区办事处" },
  { value: "桂林市", label: "桂林市" },
  { value: "百色市", label: "百色市" }
];

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    Message.error('请上传图片');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    Message.error('图片不能超过2MB!');
  }
  return isJpgOrPng && isLt2M;
}

export default class ApplicationProcess extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      data: this.props.location.state.data,
      type1: [],
      type2: [],
      type3: [],
      token: '',
      user: '',
      information: '',
      materialsList: [],
      type: '',
      checkboxType: false,
      rowMaterialsId: ''
    };
  }

  componentDidMount() {
    this.getUserInfo();
    this.getInformation()
    this.getTable();
    this.getApplicationTypeOne();
  }

  getUserInfo() {
    const token = getToken();
    fetch(Request.personaluserInfo(), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "Blade-Auth": token,
      }),
      body: {}
    })
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.code == 200) {
          console.log("用户信息responseJson:", responseJson)
          this.setState({
            token: token,
            user: responseJson.data.user
          })
        } else {
          removeAll()
        }
      })
      .catch(e => {
        const status = e.name;
        console.log('status', status)
      });
  }

  // 获取档案信息
  getInformation() {
    Http.getApplication(Request.getArchivalInformation(), {}, obj => {
      console.log('档案信息obj', obj);
      if (obj.code == 200) {
        this.setState({
          information: obj.data,
          user: Object.assign({}, this.state.user, {
            archivesId: obj.data.id,
            groupId: obj.data.id,
            idCard: obj.data.idCard,
            entitledCord: obj.data.entitledCode,
          })
        })
      } else {
        Message.error(obj.msg);
      }
    });
  }
  // 获取申请类型一级下拉
  getApplicationTypeOne() {
    let params = {
      flag: 'entitled',
      tenantId: '150000',
    };
    Http.get(Request.getApplicationTypeOne(), params, obj => {
      if (obj && obj.code == 200) {
        const data = obj.data;
        this.setState({
          type1: data
        });
      }
    });
  }

  select = (index, key) => {
    let { type3, user } = this.state;
    if (index == 1) {
      let params = {
        flag: 'level',
        tenantId: '150000',
        entitledId: key,
      };
      Http.get(Request.getApplicationTypeTwo(), params, obj => {
        if (obj && obj.code == 200) {
          const data = obj.data;
          this.setState({
            type2: data,
            user: Object.assign({}, user, { type: key })
          });
        }
      });
    } else if (index == 2) {
      console.log(key)
      let params = {
        flag: 'type',
        tenantId: '150000',
        entitledId: user.type,
        level: key
      };
      Http.get(Request.getApplicationTypeThree(), params, obj => {
        if (obj && obj.code == 200) {
          const data = obj.data;
          this.setState({
            type3: data,
            user: Object.assign({}, user, { level: key })
          });
        }
      });
    } else if (index == 3) {
      console.log(key)
      for (var i = 0; i < type3.length; i++) {
        if (key == type3[i].name) {
          this.setState({
            user: Object.assign({}, user, {
              moneyTypeId: type3[i].key,
              moneyType: type3[i].name,
              money: type3[i].money,
            })
          });
        }
      }
    }
  }

  getTable() {
    const id = this.state.data.id;
    Http.get(Request.getItemsDetail(), { id }, obj => {
      if (obj && obj.code == 200) {
        console.log("obj6666:", obj);
        const data = obj.data.materialsList;
        for (var i = 0; i < data.length; i++) {
          data[i].materialsId = data[i].id;
          delete data[i].id;
        }
        this.setState({
          // smsEntitledGroups: data.smsEntitledGroups,
          materialsList: data,
          user: Object.assign({}, this.state.user, {
            entitledType: obj.data.smsEntitledGroups.entitledTypeName,
          })
        });
      }
    });
  }

  onChange(key, value) {
    const { user } = this.state;
    this.setState({
      user: Object.assign({}, user, { [key]: value })
    });
  }

  checkbox = (value) => {
    this.setState({ checkboxType: value })
  }

  handleSubmit(e) {
    var { materialsList } = this.state;
    e.preventDefault();
    const { user } = this.state;
    delete user.id;
    delete user.account;
    delete user.authStatus;
    delete user.avatar;
    user.name = user.realName;
    delete user.realName;
    console.log("材料清单表格数据:", materialsList)
    user.preservationJson = materialsList;
    console.log("user:", user)
    if (this.state.checkboxType) {
      if (user.type == undefined || user.level == undefined || user.moneyTypeId == undefined || user.phone == '' || user.householdRegistrationAddress == undefined) {
        Message.error('请填写完整再进行提交');
      } else {
        Http.postJson(Request.getSaveApplication(), user, obj => {
          console.log("obj:", obj)
          if (obj.code == 200) {
            Message({
              message: '申请成功！',
              type: 'success'
            });
            this.props.history.push('/preferential/preferential')
          } else {
            // Message.error(obj.msg);
            Message.error('提交失败，请稍后重试');
          }
        })
      }
    } else {
      Message.error('请先阅读并同意遵守《服务协议》');
    }

  }

  handleAvatarScucess(res, file) {
    const { materialsList, rowMaterialsId } = this.state;
    console.log("res:", res); // filename   url
    console.log("file:", file);
    if (res && res.code == 200) {
      console.log(200);
      var data = res.data;
      for (var i = 0; i < materialsList.length; i++) {
        if (rowMaterialsId == materialsList[i].materialsId) {
          materialsList[i].uploadAttachmentsName = data.filename;
          materialsList[i].uploadAttachments = data.url;
        }
      }
      this.setState({
        materialsList: materialsList
      }, console.log("materialsList231231:", materialsList));
    }
  }
  onRowClick = (row) => {
    console.log("row:", row);
    this.setState({ rowMaterialsId: row.materialsId })
  }

  render() {
    const { materialsList, data, type1, type2, type3, user, information, checkboxType } = this.state;
    // console.log("111:", this.props.location.state.data)
    console.log("materialsList:", materialsList)
    let that = this;

    const fileprops = {
      name: 'file',
      showFileList: false,
      className: 'avatar-uploader',
      showUploadList: false,
      headers: {
        Authorization: 'Basic c3dvcmQ6c3dvcmRfc2VjcmV0',
      },
      action: Request.getDebugUrl() + 'blade-portal/serviceProviderInformation/getUpload',
      // action: 'http://yhbest.imwork.net:30080/blade-portal/serviceProviderInformation/getUpload',
      // beforeUpload: beforeUpload,
    };

    const columns = [
      {
        type: 'index',
        label: "序号",
        align: 'center'
      },
      {
        label: "材料名称",
        prop: "materialsName",
        align: 'center'
      },
      {
        label: "材料要求",
        prop: "materialsRequirements",
        align: 'center',
        // render(row) {
        //   return (<div style={{ color: '#18388c' }}>{row.command}</div>)
        // }
      },
      {
        label: '原件(份)',
        prop: 'original',
        align: 'center'
      },
      {
        label: '复印件(份)',
        prop: 'copies',
        align: 'center'
      }, {
        label: '范本文件',
        prop: 'file',
        align: 'center',
        render(row) {
          return (
            <Button type="text" size="small" onClick={() => window.location = `http://yhbest.imwork.net:30080/blade-portal/articleUtils/downloadSingFile?id=${row.id}`}>
              <img src={download} style={{ marginRight: '5px' }} />
              <span>{row.templateFileName}</span>
            </Button>
          );
        }
      },
      {
        label: '上传附件',
        prop: 'upload',
        align: 'center',
        render(row) {
          return (
            <Upload
              className="avatar-uploader"
              {...fileprops}
              onSuccess={(res, file) => that.handleAvatarScucess(res, file)}
            >
              {materialsList.uploadAttachmentsName ? <div>{materialsList.uploadAttachmentsName}</div> : <div><img src={upload} style={{ marginRight: '5px' }} />上传附件</div>}
            </Upload>
          )

        }
      }
    ];

    return (
      <div className="main_search_detail">
        <div className="center" style={{ marginTop: '0' }}>
          <div className="center_search">
            <div className="center_position_info"></div>
            <span style={{ color: "#18388c", fontSize: "24px" }}>
              海棠区办事处优抚补贴申请_
            </span>
            <span style={{ lineHeight: "24px", color: "#18388c" }}>
              在线办理
            </span>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>选择办理区域</span>
            </div>
          </div>
          <div className="selected_process_area">
            <span
              style={{ marginRight: "18px", color: "#333", fontSize: "14px" }}
            >
              {/* 海南省  三亚市  海棠区 */}
              {user.provinceName}  {user.cityName}  {user.countyName}
            </span>
            {/* <Select>
              {city.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select>
            <Select>
              {area.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select>
            <Select>
              {areaSmall.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select> */}
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请人基本信息</span>
            </div>
          </div>
          <div>
            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>申请人姓名</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                disabled="disabled"
                value={user.realName}
                className="application_basic_input"
                style={{ background: "#f6f6f6" }}
              ></input>
            </div>

            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>证件号码</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              {/* <input value="身份证" className="application_basic_id"></input> */}
              <input
                disabled="disabled"
                value={information.idCard}
                className="application_basic_input"
                style={{ background: "#f6f6f6" }}
              ></input>
            </div>

            {/* <div className="application_basic_info">
              <div className="application_basic_left">
                <span>性别</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                type="radio"
                name="sex"
                checked
                value="男"
                className="application_basic_sex"
              />
              <span style={{ marginLeft: "3px", marginRight: "12px" }}>男</span>
              <input
                type="radio"
                name="sex"
                value="女"
                className="application_basic_sex"
              />
              <span>女</span>
            </div> */}

            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>联系电话</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <Input type="text" className="application_basic_input" value={user.phone} onChange={this.onChange.bind(this, 'phone')} placeholder="请输入手机号码" />
            </div>
            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>联系地址</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <Input type="text" className="application_basic_input" value={user.householdRegistrationAddress} onChange={this.onChange.bind(this, 'householdRegistrationAddress')} placeholder="例：海南省海口市海府路59号" />
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项基本信息</span>
            </div>
          </div>
          <div className="item_basic_info">
            <div style={{ marginBottom: "14px" }}>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  事项名称：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  {/* 海棠区办事处优抚补贴申请 */}
                  {data.entitledName}
                </span>
              </div>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  事项编号：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  {/* 4403430000000527999931001001663001 */}
                  {data.entitledCode}
                </span>
              </div>
            </div>
            <div>
              <div className="item_basic_info_block" style={{ float: 'left' }}>
                <span style={{ fontSize: "14px", color: "#333" }}>
                  审批单位：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  {/* 海南省三亚市海棠区退役军人事务处 */}
                  {data.entitledDepartment}
                </span>
              </div>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  面向对象：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  {/* 伤残人员、三属、三红、在乡老复员军人、带病回乡退伍军人、参战退伍军人、涉核人员 */}
                  {data.objectName}
                </span>
              </div>
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请类型及金额</span>
            </div>
          </div>

          {/* <div className="application_type">
            <div>
              <div className="application_type_block">
                <span style={{ color: "#ff0000" }}>*</span>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    marginRight: "18px"
                  }}
                >
                  申请类型
                </span>
                <Select></Select>
              </div>
              <div className="item_basic_info_block">
                <span style={{ color: "#ff0000" }}>*</span>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    marginRight: "18px"
                  }}
                >
                  申请金额(元)
                </span>
                <Input value={10000.0} />
              </div>
            </div>
          </div>
           */}
          <div className="application_basic_info">
            <div className="application_basic_left">
              <span>申请类型</span>
              <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
            </div>
            <Select placeholder="请选择" onChange={(value) => this.select(1, value)} style={{ marginRight: '9px' }}> {
              type1.map(el => {
                return <Select.Option key={
                  el.key
                }
                  label={
                    el.name
                  }
                  value={
                    el.key
                  }
                />
              })
            }
            </Select>
            <Select style={{ marginRight: '9px' }}
              placeholder="请选择" onChange={(value) => this.select(2, value)}> {
                type2.map(el => {
                  return <Select.Option key={
                    el.key
                  }
                    label={
                      el.name
                    }
                    value={
                      el.name
                    }
                  />
                })
              }
            </Select>
            <Select placeholder="请选择" onChange={(value) => this.select(3, value)}> {
              type3.map(el => {
                return <Select.Option key={
                  el.key
                }
                  label={
                    el.name
                  }
                  value={
                    el.name
                  }
                />
              })
            }
            </Select>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>材料清单</span>
            </div>
          </div>

          <div style={{ margin: '20px 19px 40px 19px ' }}>
            <Table
              style={{ width: '100%' }}
              columns={columns}
              data={materialsList}
              border={true}
              onRowClick={(row) => this.onRowClick(row)}
            />
            <div className="check_agree">
              <Checkbox checked={checkboxType} onChange={(value) => this.checkbox(value)}><span style={{ marginLeft: '5px' }}>我已阅读并同意遵守<span style={{ color: '#18388c' }}>《服务协议》</span></span></Checkbox>
            </div>
            <div>
              {/* <div className="detail_submit"><Button><Link to='./applicationGuide'><span style={{ color: '#fff' }}>提交</span></Link></Button></div> */}
              <div className="detail_submit"><Button onClick={this.handleSubmit.bind(this)}>提交</Button></div>

              {/* <div className="detail_save"><Button>暂存</Button></div> */}
            </div>
          </div>
        </div>
        {/* 当前位置 */}
      </div>
    );
  }
}
